module.exports = __webpack_public_path__ + "img/changeTime.0c8a01ac.svg";